module.exports = __webpack_public_path__ + "img/Lavish3.4b8bef0a.jpg";